<div class="w-100">
    <div class="page-info">
        <h3 style="margin: 25px; font-weight: 500; font-size:25px; color: #2a457a;">Tally Receipts</h3>
    </div>
    <div class="page-next"><mat-icon mat-list-icon routerLink="/daybook">arrow_circle_right</mat-icon></div>
</div>


<div class="container" id="l_receiptHdrDiv" [ngClass]="{'frozen-div': l_IsDivFrozen}">
    <!-- Book Number -->
    <mat-form-field class="book-number-field" appearance="outline">
        <mat-label class="custom-mat-label">Book Number</mat-label>
        <input matInput placeholder="Enter Book Number" [(ngModel)]="l_formDataTallyReceiptHdr.bookNumber"
            [formControl]="lFN_validate('bookNumber')" required>
        <mat-error *ngIf="!l_formDataTallyReceiptHdr.bookNumber">Book Number is required</mat-error>
        <mat-error *ngIf="lFN_validate('bookNumber').hasError('pattern')">Book Number must be less than 3
            digits</mat-error>
    </mat-form-field>
    
    <!-- Transaction Category -->
    <mat-form-field class="category-field" appearance="outline">
        <mat-label class="custom-mat-label">Transaction Category</mat-label>
        <mat-select [(ngModel)]="l_formDataTallyReceiptHdr.txncategoryId"
            (selectionChange)="lFN_GetPurposeSelect($event); lFN_GenerateReceiptNotesList();" required>
            <mat-option *ngFor="let l_category of l_categorySelect" [value]="l_category.txncategoryId">
                {{ l_category.name }}
            </mat-option>
        </mat-select>
        <mat-error *ngIf="!l_formDataTallyReceiptHdr.txncategory">Transaction Category is required</mat-error>
    </mat-form-field>

    <!-- User Name -->
    <mat-form-field class="username-field" appearance="outline">
        <mat-label class="custom-mat-label">User Name</mat-label>
        <input matInput placeholder="Enter User Number" [(ngModel)]="l_formDataTallyReceiptHdr.username"
            [disabled]="true">
    </mat-form-field>
    <button mat-raised-button color="primary" class="custom-button-blue" (click)="lFN_ToggleFreeze();">{{ l_FreezeLabel }}</button>
    <button mat-raised-button color="primary" class="custom-button-blue" (click)="lFN_ToggleFixDates();">{{ l_FixDateLabel }}</button>
    <button mat-raised-button color="primary" class="custom-button-blue" (click)="lFN_ToggleFixDates();">Pull Receipt Detail</button>
    <mat-checkbox class="example-margin" [(ngModel)]="l_autoyogprakashFiller">Auto Yogprakash Entries</mat-checkbox>
</div>

<div class="container">
    <!-- Receipt Number -->
    <mat-form-field class="username-field" appearance="outline">
        <mat-label class="custom-mat-label">Receipt Number</mat-label>
        <input matInput placeholder="Enter Receipt Number" [(ngModel)]="l_formDataTallyNarrationDetails.receiptNbr"
            [formControl]="lFN_validate('receiptNbr')" required (blur)="lFN_VerifyReceiptNbr();">
        <mat-error *ngIf="!l_formDataTallyNarrationDetails.receiptNbr">Receipt Number is required</mat-error>
        <mat-error *ngIf="lFN_validate('receiptNbr').hasError('pattern')">Receipt no. only in number format</mat-error>
    </mat-form-field>


    <!-- Choose a date -->
    <mat-form-field appearance="outline">
        <mat-label class="custom-mat-label" *ngIf="(l_IsFixedDate === false)">Choose a date</mat-label>
        <mat-label class="custom-mat-label-primary" *ngIf="(l_IsFixedDate === true)">Fixed Txndate</mat-label>
        <input matInput [matDatepicker]="picker" [(ngModel)]="l_formDataTallyReceiptDetails.txndate" [min]="minDatePicker" [max]="maxDatePicker" required>
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
        <mat-error *ngIf="!l_formDataTallyReceiptDetails.txndate">TxnDate is required</mat-error>
    </mat-form-field>

    <!-- Salutation -->
    <mat-form-field class="salutation-field" appearance="outline">
        <mat-label class="custom-mat-label">Salutation</mat-label>
        <mat-select [(ngModel)]="l_formDataTallyNarrationDetails.salutation">
            <mat-option *ngFor="let salutation of salutationEnum" [value]="salutation.value">
                {{ salutation.viewValue }}
            </mat-option>
        </mat-select>
    </mat-form-field>

    <mat-form-field class="username-field" appearance="outline">
        <mat-label class="custom-mat-label">Firstname</mat-label>
        <input matInput placeholder="Enter Firstname" [(ngModel)]="l_formDataTallyNarrationDetails.firstName"
            [formControl]="lFN_validate('firstName')" required>
        <mat-error *ngIf="!l_formDataTallyNarrationDetails.firstName">First Name is required</mat-error>
        <mat-error *ngIf="lFN_validate('firstName').hasError('pattern')">First Name must be in english only</mat-error>
    </mat-form-field>
    <mat-form-field class="username-field" appearance="outline">
        <mat-label class="custom-mat-label">Middlename</mat-label>
        <input matInput placeholder="Enter Middlename" [(ngModel)]="l_formDataTallyNarrationDetails.middleName"
            [formControl]="lFN_validate('middleName')">
        <mat-error *ngIf="lFN_validate('middleName').hasError('pattern')">Middle Name must be in english
            only</mat-error>
    </mat-form-field>
    <mat-form-field class="username-field" appearance="outline">
        <mat-label class="custom-mat-label">Lastname</mat-label>
        <input matInput placeholder="Enter Lastname" [(ngModel)]="l_formDataTallyNarrationDetails.lastName"
            [formControl]="lFN_validate('lastName')" [required]="l_catgoryNameGlobal != 'Yogprakash'">
        <mat-error *ngIf="(!l_formDataTallyNarrationDetails.lastName && l_catgoryNameGlobal != 'Yogprakash')">Last Name is required</mat-error>
        <mat-error *ngIf="lFN_validate('lastName').hasError('pattern')">Last Name must be in english only</mat-error>
    </mat-form-field>

    <div class="new-row"></div>

    <mat-form-field class="address-field" appearance="outline">
        <mat-label class="custom-mat-label">Address</mat-label>
        <input matInput placeholder="Enter Address" [(ngModel)]="l_formDataTallyNarrationDetails.address" [required]="l_catgoryNameGlobal != 'Yogprakash'">
        <mat-error *ngIf="(!l_formDataTallyNarrationDetails.address && l_catgoryNameGlobal != 'Yogprakash')">Address is required</mat-error>
    </mat-form-field>
    <mat-form-field class="username-field" appearance="outline">
        <mat-label class="custom-mat-label">City</mat-label>
        <input matInput placeholder="Enter City" [(ngModel)]="l_formDataTallyNarrationDetails.city" [required]="l_catgoryNameGlobal != 'Yogprakash'">
        <mat-error *ngIf="(!l_formDataTallyNarrationDetails.city && l_catgoryNameGlobal != 'Yogprakash')">City is required</mat-error>
    </mat-form-field>
    <mat-form-field class="username-field" appearance="outline">
        <mat-label class="custom-mat-label">Pincode</mat-label>
        <input matInput placeholder="Enter Pincode" [(ngModel)]="l_formDataTallyNarrationDetails.pinCd"
            [formControl]="lFN_validate('pinCd')">
        <mat-error *ngIf="lFN_validate('pinCd').hasError('pattern')">Pincode only in number format</mat-error>
    </mat-form-field>

    <div class="new-row"></div>

    <mat-form-field class="username-field" appearance="outline">
        <mat-label class="custom-mat-label">Mobile Number</mat-label>
        <input matInput placeholder="Enter Mobile Number" [(ngModel)]="l_formDataTallyNarrationDetails.mobileNbr"
            [formControl]="lFN_validate('mobileNbr')">
        <mat-error *ngIf="lFN_validate('mobileNbr').hasError('pattern')">Mobile no. only in numeric more than ten
            digits</mat-error>
    </mat-form-field>
    <mat-form-field class="username-field" appearance="outline">
        <mat-label class="custom-mat-label">Email</mat-label>
        <input matInput placeholder="Enter email" [(ngModel)]="l_formDataTallyNarrationDetails.email">
    </mat-form-field>
    <mat-form-field class="username-field" appearance="outline">
        <mat-label class="custom-mat-label">Pan Card</mat-label>
        <input matInput placeholder="Enter Pancard No" [(ngModel)]="l_formDataTallyNarrationDetails.panCrdNbr"
            [formControl]="lFN_validate('panCrdNbr')">
        <mat-error *ngIf="lFN_validate('panCrdNbr').hasError('pattern')">Invalid Pan no.</mat-error>
    </mat-form-field>
    <mat-form-field class="username-field" appearance="outline">
        <mat-label class="custom-mat-label">Aadhar Card</mat-label>
        <input matInput placeholder="Enter Aadhar No" [(ngModel)]="l_formDataTallyNarrationDetails.aadharCrdNbr"
            [formControl]="lFN_validate('aadharCrdNbr')">
        <mat-error *ngIf="lFN_validate('aadharCrdNbr').hasError('pattern')">Invalid Aadhar no.</mat-error>
    </mat-form-field>

    <div class="new-row"></div>

    <!-- <mat-form-field class="address-field" appearance="outline">
        <mat-label class="custom-mat-label">Receipt Notes</mat-label>
        <input matInput placeholder="Enter Receipt Notes" [(ngModel)]="l_formDataTallyNarrationDetails.notes">
    </mat-form-field> -->

    <mat-form-field class="address-field" appearance="outline">
        <mat-label class="custom-mat-label">Receipt Notes</mat-label>
        <input matInput placeholder="Enter Receipt Notes" [(ngModel)]="l_formDataTallyNarrationDetails.notes"
            [matAutocomplete]="auto" (input)="lFN_FilterNotes();">
        <mat-autocomplete #auto="matAutocomplete">
            <mat-option *ngFor="let l_receiptNote of l_filteredNotesList" [value]="l_receiptNote">
                {{ l_receiptNote }}
            </mat-option>
        </mat-autocomplete>
    </mat-form-field>
    

    <mat-form-field class="username-field" appearance="outline">
        <mat-label class="custom-mat-label">Collected By</mat-label>
        <input matInput placeholder="Collected By" [(ngModel)]="l_formDataTallyNarrationDetails.collectedBy">
    </mat-form-field>

    <!-- Amount Received -->
    <mat-form-field class="username-field" appearance="outline">
        <mat-label class="custom-mat-label">Amount Received</mat-label>
        <input matInput placeholder="Enter Amount" [(ngModel)]="l_formDataTallyReceiptDetails.amount" (input)="lFN_FormatAmount($event);"
            [formControl]="lFN_validate('amount')" required>
        <mat-error *ngIf="!l_formDataTallyReceiptDetails.amount">Amount is required</mat-error>
        <mat-error *ngIf="lFN_validate('amount').hasError('pattern')">Amount only in number format</mat-error>
    </mat-form-field>

</div>

<div class="container">

    <!-- Transaction Purpose -->
    <mat-form-field class="purpose-field" appearance="outline">
        <mat-label class="custom-mat-label">Transaction Purpose</mat-label>
        <mat-select [(ngModel)]="l_formDataTallyReceiptHdr.purposeId" required
            (selectionChange)="lFN_GenerateModePaymentList();">
            <mat-option *ngFor="let l_purpose of l_purposeSelect" [value]="l_purpose.purposeId">
                {{ l_purpose.purpose }}
            </mat-option>
        </mat-select>
        <mat-error *ngIf="!l_formDataTallyReceiptHdr.purpose">Transaction Purpose is required</mat-error>
    </mat-form-field>

    <!-- Mode of Payment -->
    <mat-form-field class="purpose-field" appearance="outline">
        <mat-label class="custom-mat-label">Mode of Payment</mat-label>
        <mat-select [(ngModel)]="l_formDataTallyReceiptDetails.modeOfPayment"
            (selectionChange)="lFN_EnableDisableFields($event)" required>
            <mat-option *ngFor="let modeOfPayment of modeOfPaymentEnum" [value]="modeOfPayment.value">
                {{ modeOfPayment.viewValue }}
            </mat-option>
        </mat-select>
        <mat-error *ngIf="!l_formDataTallyReceiptDetails.modeOfPayment">Mode Of Payment is required</mat-error>
    </mat-form-field>

    <!-- Transaction Id - Cheque No -->
    <mat-form-field class="username-field" appearance="outline">
        <mat-label class="custom-mat-label">Transaction Id - Cheque No.</mat-label>
        <input matInput placeholder="Enter Transaction Id - Cheque No."
            [(ngModel)]="l_formDataTallyReceiptDetails.modeTranId" [disabled]="l_disableModeTranId">
    </mat-form-field>

    <!-- Bank Name -->
    <mat-form-field class="username-field" appearance="outline">
        <mat-label class="custom-mat-label">Bank Name</mat-label>
        <input matInput placeholder="Enter Bank Number" [(ngModel)]="l_formDataTallyReceiptDetails.modeBankName"
            [disabled]="l_disableModeBankName">
    </mat-form-field>
    <mat-slide-toggle [checked]="l_formDataTallyReceiptDetails.mapexternal" (change)="lFN_OnToggleChange($event)">
        <mat-label class="custom-mat-label">Map External</mat-label>
    </mat-slide-toggle>
</div>

<div class="custom-container">
    <button mat-raised-button class="submit-button" (click)="lFN_SubmitTallyReceiptDtls();">Submit Tally Entry</button>
</div>